export const DEFAULT_RESET_PASSWORD = '1';
